module.exports = __webpack_public_path__ + "static/media/slackSmall.9d96a3a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WelcomeContent/slackSmall.png
 ** module id = 621
 ** module chunks = 0
 **/